/*
 * action creators
 */

export const updateResourceSearchText = ({ searchText }) => (
  {
    type: 'UPDATE_RESOURCE_SEARCH_TEXT',
    searchText,
  }
);

export const updateTagSearchText = ({ searchText }) => (
  {
    type: 'UPDATE_TAG_SEARCH_TEXT',
    searchText,
  }
);

export const updateResults = ({ results }) => (
  {
    type: 'UPDATE_RESULTS',
    results,
  }
);

export const addResource = resource => (
  {
    type: 'ADD_RESOURCE',
    resource,
  }
);

export const updateResource = resource => (
  {
    type: 'UPDATE_RESOURCE',
    resource,
  }
);

export const addTag = tag => (
  {
    type: 'ADD_TAG',
    tag,
  }
);

export const updateTag = tag => (
  {
    type: 'UPDATE_TAG',
    tag,
  }
);

export const deleteTag = tagId => (
  {
    type: 'DELETE_TAG',
    tagId,
  }
);

export const addGroup = group => (
  {
    type: 'ADD_GROUP',
    group,
  }
);

export const updateGroup = group => (
  {
    type: 'UPDATE_GROUP',
    group,
  }
);

export const deleteGroup = groupId => (
  {
    type: 'DELETE_GROUP',
    groupId,
  }
);

export const setView = view => (
  {
    type: 'SET_VIEW',
    view,
  }
);

export const openTagEditor = ({ tag, isNew }) => {
  if (isNew) {
    return {
      type: 'OPEN_TAG_EDITOR',
      tag: {
        group: '',
        display: '',
        ...tag,
      },
      isNew,
    };
  }
  return {
    type: 'OPEN_TAG_EDITOR',
    tag,
    isNew,
  };
};

export const closeTagEditor = () => (
  {
    type: 'CLOSE_TAG_EDITOR',
  }
);

export const openGroupEditor = ({ group, isNew }) => (
  {
    type: 'OPEN_GROUP_EDITOR',
    group,
    isNew,
  }
);

export const closeGroupEditor = () => (
  {
    type: 'CLOSE_GROUP_EDITOR',
  }
);

export const openResourceEditor = resource => (
  {
    type: 'OPEN_RESOURCE_EDITOR',
    resource,
  }
);

export const closeResourceEditor = () => (
  {
    type: 'CLOSE_RESOURCE_EDITOR',
  }
);

export const setSort = sortBy => (
  {
    type: 'SET_SORT',
    sortBy,
  }
);

export const activateResourceSearch = ({ results, queries, searchText }) => (
  {
    type: 'ACTIVATE_RESOURCE_SEARCH',
    queries,
    results,
    searchText,
  }
);



// WEBPACK FOOTER //
// ./src/actions/index.js